import { render, staticRenderFns } from "./headers.vue?vue&type=template&id=a5b14b88&scoped=true&"
import script from "./headers.vue?vue&type=script&lang=js&"
export * from "./headers.vue?vue&type=script&lang=js&"
import style0 from "./headers.vue?vue&type=style&index=0&lang=css&"
import style1 from "./headers.vue?vue&type=style&index=1&id=a5b14b88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b14b88",
  null
  
)

export default component.exports